import React from "react";
import classes from "./LoadingSpinner.module.css";
import LoadingIcon from "./../../icons/loading.svg";

const LoadingSpinner = () => {
  return (
    <div className={classes.loadingContainer}>
      <img
        style={{ margin: "0.5rem" }}
        src={LoadingIcon}
        width={85}
        height={85}
      />
    </div>
  );
};

export default LoadingSpinner;
